import Accordion from '@web/components/Accordion'
import { DemoButton } from '@web/components/DemoButton'

type SolutionsUseCasesProps = {
  header: string
  accordions: {
    title: string
    subtitle?: string
    content: React.ReactNode
  }[]
  image: {
    src: string
    alt: string
  }
}

const SolutionsUseCases = ({ header, accordions, image }: SolutionsUseCasesProps) => {
  return (
    <section className="bg-neutral-muted py-24 sm:py-16">
      <div className="space-y-8 mx-auto max-w-5xl px-6 lg:px-8">
        <h1 className="text-4xl font-light text-brand-blue">{header}</h1>
        <div className="flex gap-8 flex-wrap md:flex-nowrap">
          <div className="flex flex-col items-start gap-4 flex-1 md:min-w-[440px]">
            <Accordion
              items={accordions.map(({ title, subtitle, content }) => ({
                value: title,
                title,
                subtitle,
                content,
              }))}
            />
            <div className="pt-6">
              <DemoButton />
            </div>
          </div>
          {image && (
            <div className="flex items-start justify-center md:flex-1 mx-auto md:w-auto w-full">
              <img
                src={image.src}
                alt={image.alt}
                className="h-auto w-full rounded-lg shadow-md max-h-[300px] md:max-h-none object-cover"
              />
            </div>
          )}
        </div>
      </div>
    </section>
  )
}

export default SolutionsUseCases
